const SearchUtils = {
  INTERVALS: ['minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'],

  histogramIntervals() {
    return this.INTERVALS;
  },
};

export default SearchUtils;
